import app from '../app.first';
import $ from 'jquery';

app.IntroduceYourselfRecorder = class extends app.Component {
	//this function runs on every single page, so call functions from this function that you need to run on every page
	constructor($this) {
		super($this);
		$(() => this.onDocumentReady($this));

		this.$fileUploads = $('.audio-path');
	}

	onDocumentReady($this) {
		var myRecorder = {
			objects: {
				context: null,
				stream: null,
				recorder: null
			},
			init: function () {
				if (null === myRecorder.objects.context) {
					myRecorder.objects.context = new (
							window.AudioContext || window.webkitAudioContext
							);
				}
			},
			start: function () {
				var options = {audio: true, video: false};
				navigator.mediaDevices.getUserMedia(options).then(function (stream) {
					myRecorder.objects.stream = stream;
					myRecorder.objects.recorder = new Recorder(
							myRecorder.objects.context.createMediaStreamSource(stream),
							{numChannels: 1}
					);
					myRecorder.objects.recorder.record();
				}).catch(function (err) {
					console.log(err);
				});
			},
			stop: function () {
				if (null !== myRecorder.objects.stream) {
					myRecorder.objects.stream.getAudioTracks()[0].stop();
				}

				if (null !== myRecorder.objects.recorder) {
					myRecorder.objects.recorder.stop();
					myRecorder.objects.recorder.exportWAV(function (blob) {
						var fd = new FormData();
						fd.append('audio_path', blob);

						$.ajax({
							url: "/ajax/save-introduce-yourself",
							data: fd,
							processData: false,
							contentType: false,
							cache: false,
							method: 'POST',
							beforeSend: (xhr) => {
								xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
							},
							success: function(response) {
								if (response.success) {
									//location.reload(true)
								}
								delayDisplayNextBtn()
								$('.back-to-dashboard').show();
							},
						});
					});
				}
			}
		};

		// Initialize the recorder
		
		var startTime, endTime;
		var recordingComplete = false;
		var timeOutId = 0;

		// Prepare the record button
		$('.record-button').on('click', function (e) {
            e.preventDefault();

			if (recordingComplete) {
				return false;
			}

			clearTimeout(timeOutId);

			if (timeOutId == 0) {
				myRecorder.init();
				timeOutId = setTimeout(stopRecording, 91000);
			}

			// Get the button state
			var buttonState = !!$(this).attr('data-recording');

			// Toggle
			if (!buttonState) {
				startTime = new Date();

				startRecording();

				$(this).attr('data-recording', 'true');
				$('.upload-audio-file-container').hide();
				$('.or-container').hide();
				$(this).find('.record-start').hide();
				$(this).find('.record-end').show();

			} else {
                stopRecording();
				clearTimeout(timeOutId);
			}
		});

		function recorderTimer () {
			endTime = new Date();
			var timeDiff = endTime - startTime; //in ms
			// strip the ms
			timeDiff /= 1000;

			// get seconds 
			return  Math.round(timeDiff);
			
		}

		function delayDisplayNextBtn () {
			$('.record-label').html('Done!<br>You can replace your recording later.');
			$('.button-dprimary').show();
		}

		function updateHTML () {
			var time = recorderTimer();
			var seconds =  '';
			if (time == 1) {
				seconds =  time + ' second';
			} else {
				seconds = time + ' seconds'
			}
			
			$("#recorder-counter").html(seconds);
		}

		function startRecording () {
			$('.button-dprimary').hide();
			document.getElementById("recorder-counter").innerHTML = '0 seconds';
			myRecorder.start();
			setInterval(updateHTML, 1000);
		}

		function stopRecording () {
			timeOutId = 0;
			var seconds = recorderTimer();

			if (seconds < 60) {
				alert('Recording too short. Please record atleast 60 seconds but not more than 90 seconds.');
				$('.spinner').hide();
				$('.record-start').show();
				$('.record-end').hide();
				$('.record-button').attr('data-recording', '');
			}

			else if (seconds >= 60 && seconds <= 90) {
				$('.back-to-dashboard').hide();
				myRecorder.stop();
				recordingComplete = true;
				$('.spinner').hide();
				$('.record-end').hide();
				$('.record-complete').show();

				$('.record-label').html('Saving...');
				return true;
			}

			else {
				alert('Recording too long. Please record atleast 60 seconds but not more than 90 seconds.');
				$('.spinner').hide();
				$('.record-start').show();
				$('.record-end').hide();
				$('.record-button').attr('data-recording', '');
			}

			$('.button-dprimary').show();
			return false;
		}

		this.$fileUploads.on('change', function() {
            let $this = $(this);
			$('.iy_audio_filename').html($this.val().split('\\').pop());
        });


		$('.upload-voice-note-button').click(function (e) {
			$('#iy_audio_file').click();
		});
	}

}
